export const ORG_ORG_UNIT_SELECTOR_MODE = {
  MULTIPLE_ORG_MULTIPLE_ORG_UNIT_SELECTION: 1,
  SINGLE_ORG_MULTIPLE_UNIT_SELECTION: 2,
  SINGLE_ORG_SINGLE_UNIT_SELECTION: 3
};
